import React, { useEffect, useState } from "react";
import {
  Box,
  TextField,
  FormControl,
  Button,
  Grid,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import Header from "../../components/Header";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  getCategoryAction,
  updateCategoryAction,
} from "../../redux/actions/categoryAction";
import LoadingIndicator from "../../components/loadingIndicator";

const EditCategory = () => {
  const location = useLocation();
  const { pathname } = location;
  const categoryId = pathname.split("/").pop();
  const [err, setErr] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const initialFormState = {
    title: "",
    isActive: "",
  };

  const [formData, setFormData] = useState(initialFormState);

  useEffect(() => {
    const fetchCategoryDetails = async () => {
      try {
        const response = await dispatch(getCategoryAction(categoryId));
        if (response && response.success) {
          const categoryDetails = response.category;
          setFormData(categoryDetails);
        } else {
          console.log("Error fetching Category details");
          toast.error("Failed to fetch");
        }
      } catch (error) {
        console.log("Error", error);
        toast.error("Error fetching details");
      }
    };
    fetchCategoryDetails(); // Call the function here
  }, [categoryId, dispatch]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBlur = async (e) => {
    const fieldName = e.target.name;
    try {
      // await validationSchema.validateAt(fieldName, formData);
      setErr({ ...err, [fieldName]: "" });
    } catch (error) {
      setErr({ ...err, [fieldName]: error.message });
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // await validationSchema.validate(formData, { abortEarly: false });
      setLoading(true); // Start loading
      const updatedFormData = {
        ...formData,
      };

      const response = await dispatch(
        updateCategoryAction(categoryId, updatedFormData)
      );
      if (response) {
        toast.success("Categry updated successfully");
        navigate("/category");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else {
        toast.error("Failed to update Category");
      }
    } catch (validationErrors) {
      // Handle validation errors
      const errors = {};
      // if (validationErrors.inner) {
      //   validationErrors.inner.forEach((validationError) => {
      //     errors[validationError.path] = validationError.message;
      //   });
      // }
      setErr(errors);
    } finally {
      setLoading(false); // Stop loading
    }
  };

  return (
    <Box mt="1.5rem" mb="2.5rem" ml="2.5rem" mr="2.5rem">
      <Header title="EDIT CATEGORY" />
      <form onSubmit={handleSubmit}>
        <FormControl fullWidth margin="normal">
          {/* TITLE */}
          <TextField
            label="Title"
            name="title"
            onChange={handleChange}
            onBlur={handleBlur}
            value={formData.title}
            margin="normal"
          />
          {err.title && (
            <Grid item>
              <Typography color="error">{err.title}</Typography>
            </Grid>
          )}{" "}
          {/* Is-Active */}
          <FormControl fullWidth margin="normal">
            <InputLabel>Is Active</InputLabel>
            <Select
              name="isActive"
              value={formData.isActive}
              onBlur={handleBlur}
              onChange={handleChange}
            >
              <MenuItem value="true">True</MenuItem>
              <MenuItem value="false">False</MenuItem>
            </Select>
          </FormControl>
        </FormControl>
        {err.isActive && (
          <Grid item>
            <Typography color="error">{err.isActive}</Typography>
          </Grid>
        )}{" "}
        {/* SUBMIT BUTTON */}
        <Grid container justifyContent="center" alignItems="center">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            startIcon={<SendIcon />}
          >
            Submit
          </Button>
        </Grid>
      </form>
      {loading && <LoadingIndicator />}
    </Box>
  );
};

export default EditCategory;
